import { useEffect, useState } from 'react';

import { meetingStore } from '@/features/meetings/meetings.state';

import { formatElapsed } from './quick-create.utils';

const useNow = (enabled: boolean) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) return;
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, [enabled]);

  return now;
};

export const useActiveRecording = () => {
  const recording = meetingStore.recording;
  const isRecording = recording.status === 'recording';
  const now = useNow(isRecording);

  if (!isRecording) return undefined;

  return {
    meetingId: recording.meetingId,
    elapsed: formatElapsed(now - recording.startedAt.getTime()),
  };
};
